export const logger = !['production'].includes(<string>process.env.ENV)
  ? console
  : {
      log(..._: any[]) {},
      error(..._: any[]) {},
      warn(..._: any[]) {},
    };
